import { gql } from './apollo';

export const GET_PROPERTIES = gql`
    {
        table(
            name: "property__c"
            filter: [
                {
                    table: "property__c"
                    left: "name"
                    right: "Ivanhoe Cambridge%"
                    expression: "NOT iLIKE"
                }
                { left: "sfid", right: "null", expression: "!=" }
                { left: "isdeleted", right: "false", expression: "=" }
            ]
            limit: 99
            orderBy: "name"
        )
    }
`;

export const GET_PROPERTIES_FOR_USER = gql`
    query ($user_sfid: MultiTypeInput!) {
        table(
            name: "property__c"
            join: [
                { table: "property_propertyuser__c", fk: "property__c", joinFk: "sfid" }
                {
                    table: "propertyuser__c"
                    fk: "sfid"
                    joinTable: "property_propertyuser__c"
                    joinFk: "propertyuser__c"
                }
            ]
            filter: [
                {
                    table: "property__c"
                    left: "name"
                    right: "Ivanhoe Cambridge%"
                    expression: "NOT iLIKE"
                }
                {
                    table: "property_propertyuser__c"
                    left: "isdeleted"
                    right: "false"
                    expression: "="
                }
                { table: "propertyuser__c", left: "sfid", right: $user_sfid, expression: "=" }
                { left: "sfid", right: "null", expression: "!=" }
                { left: "isdeleted", right: "false", expression: "=" }
            ]
            limit: 99
            orderBy: "name"
        )
    }
`;
